import { BitrixVue } from 'ui.vue';
import './imports.js';

import '../configLeft/ConfigLeft.js';
import '../steps/steps';
import '../resultBlock/resultBlock.js';
// import '../additional/additionalWrap.js'
// import '../confirmBlock/completeButton.js'
import '../confirmBlock/confirmBlock.js';
import '../mobileDoor/mobileDoor.js';
BitrixVue.component('Main', {
	data() {
		return {
			activeBackground: 0,
			interierImages: [
				{
					common: '/giper-config/assets/images/interier/interier_1.jpg',
					mini: '/giper-config/assets/images/interier/interier_1-1.jpg',
				},
				{
					common: '/giper-config/assets/images/interier/interier_2.jpg',
					mini: '/giper-config/assets/images/interier/interier_2-2.jpg',
				},
				{
					common: '/giper-config/assets/images/interier/interier_3.jpg',
					mini: '/giper-config/assets/images/interier/interier_3-3.jpg',
				},
				{
					common: '/giper-config/assets/images/interier/interier_4-4.png',
					mini: '/giper-config/assets/images/interier/interier_4.png',
				},
			],
			isIncreaseTrigger: false,
      previewImage: null,
		};
	},
	props: [],
	methods: {
		setActiveBackground(index) {
			this.activeBackground = index;
		},
		isShowResultBlock() {
			return this.$store.state.basket.length > 0;
		},
		isShowConfirmBlock() {
			return this.$store.state.basket.length > 0;
		},
		showModal(modal) {
			this.$refs[modal].open();
		},
		closeModal(modal) {
			this.$refs[modal].close();
		},
	},
	template: `
<div class="config">
  <div class="config-container">
    <div class="config-wrapper">
      <h1 class="config-title">Конфигуратор межкомнатных дверей</h1>
      <div class="config-main">
        <div class="config-left">
          <ConfigLeft :storePosition="this.$store.state.position" :totalAmount="this.$store.state.totalAmount"
            :positionPrice="this.$store.state.positionPrice" v-on:showInterier="showModal($event)" :triggerIncrease="isIncreaseTrigger"  v-on:destroyFancy="isIncreaseTrigger = false" :previewDoor="this.$store.state.previewDoor" v-on:previewForInterier='previewImage = $event' :basketChange="this.$store.state.basketChange" :imageLoading="this.$store.state.imageLoading"/>
        </div>
        <div class="config-right">
          <Steps v-bind="this.$store.state.position" :totalAmount="this.$store.state.totalAmount"
            :positionPrice="this.$store.state.positionPrice" />
        </div>
        <ResultBlock v-if="this.isShowResultBlock()" :basket="this.$store.state.basket"
          :totalAmount="this.$store.state.totalAmount" />
        <ConfirmBlock v-if="this.isShowConfirmBlock()" v-bind="this.$store.state.position"
          :totalAmount="this.$store.state.totalAmount"/>
        <MobileDoor v-bind="this.$store.state.position" :totalAmount="this.$store.state.totalAmount"
          :positionPrice="this.$store.state.positionPrice" :basketLength="this.$store.state.basket.length" v-on:increaseImage="isIncreaseTrigger = true" :previewDoor="this.$store.state.previewDoor" />
      </div>
    </div>
  </div>

  <ui-modal ref="interiorModal" transition="fade" class="interior-modal config-modal" size="large">
    <div class="interior-modal__wrap">
      <div class="interior-modal__left">
        <img class="interior-modal__background" :src="interierImages[activeBackground].mini" alt="">
        <img class="interior-modal__door" v-if="this.$store.state.position.renderImage" :src="this.$store.state.position.renderImage" alt="">
        <img class="interior-modal__door" v-else :src="previewImage" alt="">
      </div>
      <div class="interior-modal__right">
        <div class="interior-modal__title">Выберите интерьер</div>
        <div class="interior-modal__items">
          <div class="interior-modal__item" @click="activeBackground = index" :class="{active: activeBackground === index}" v-for="(interier, index) of interierImages" :key="index">
            <img class="interior-modal__item-image" :src="interier.common"
              alt="">
          </div>
        </div>
        <div class="interior-modal__close" @click="closeModal('interiorModal')">Вернуться в конфигуратор</div>
      </div>
    </div>
  </ui-modal>
</div>
`,
});
